import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { OrderTypeConstant, PrintColorsConstant } from 'src/app/core';
import { config } from '../../../../../../config/config';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dynamic-content',
  templateUrl: './dynamic-content.component.html',
  styleUrls: ['./dynamic-content.component.scss'],
})
export class DynamicContentComponent implements OnInit {
  private _config!: any;
  showMoreClicked = false;

  @Output() scroll = new EventEmitter<any>();

  @ViewChild('gallery', { read: ElementRef }) public gallery: ElementRef<any>;
  scrollTop = 0;

  @Input() set config(value: any) {
    this._config = value;
  }

  get config(): any {
    if (this._config != null) {
      return this._config;
    }
    return null;
  }

  constructor(
    private viewportScroller: ViewportScroller,
    private router: Router
  ) {}

  ngOnInit() {}

  public onNextElement(): void {
    this.scrollTop += 200;

    this.gallery.nativeElement.scrollTo({
      top: this.scrollTop,
      left: 0,
      behavior: 'smooth',
    });
  }

  public ViewMore($element: HTMLElement): void {
    console.log($element);
    this.showMoreClicked = !this.showMoreClicked;
    $element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  public scrollPrintOrder() {
    this.scroll.emit();
  }

  getRoute(event: any) {
    var goRoute = event.target.getAttribute('href');
    this.router.navigate([goRoute]);
  }
}
